import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten4: "#F7F7F7",
          lighten1: "#404347",
          base: "#393C40",
          darken1: "#202C39",
        },
        secondary: {
          base: "#FF7F00",
        },
        grey: {
          lighten3: "#85888C",
        },
        accent: "#246EB9",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
